export const styles = ({ palette }) => ({
  warningMessage: {
    backgroundColor: palette.warning.main,
    padding: 16,
  },
});
